import { AxiosRequestConfig } from "axios";
import http from "../base/http.service";
import { UserDto } from "../account/account.dto";
import { SurveyResultsResponse } from "../forms/form.dto";

const services = {
  GetUser(id: string, config?: AxiosRequestConfig<any> | undefined) {
    return http.get<UserDto>(`admin/getuser/${id}`, config);
  },
  GetAllUser(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<UserDto[]>(`admin/getalluser`, config);
  },
  GetAllMainUsers(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<UserDto[]>(`Admin/GetAllMainUsers`, config);
  },

  MakeOsbukUser(id: number, config?: AxiosRequestConfig<any> | undefined) {
    return http.put<string>(`admin/makeosbukuser/${id}/`, config);
  },
  
  GetSurveyResults(config?: AxiosRequestConfig<any> | undefined) {
    return http.get<SurveyResultsResponse>("admin/survey-results", config);
  }
};

export default services;
